export const INSTALLATION_STATUS = Object.freeze({
  PENDING: "pending_installation",
  READY_FOR_DELIVERY: "ready_for_delivery",
  READY_FOR_INSTALLATION: "ready_for_installation",
  SCHEDULED: "scheduled",
  IN_PROGRESS: "in_progress",
  INSTALLED: "installed",
  ARCHIVED: "archived",
});

export const INSTALLATION_STAGE = Object.freeze({
  PREPARE: "prepare",
  CONFIRMATION: "confirmation",
  PROGRESS: "progress",
  DONE: "done",
});

export const INSTALLATION_STAGE_CONFIG = Object.freeze([
  {
    key: INSTALLATION_STAGE.PREPARE,
    label: "À préparer",
    description: "Informations et affectation",
    query: { status: INSTALLATION_STATUS.PENDING },
  },
  {
    key: INSTALLATION_STAGE.CONFIRMATION,
    label: "En attente confirmation livraison",
    description: "Bon de livraison partagé au client",
    query: { status: INSTALLATION_STATUS.READY_FOR_DELIVERY },
  },
  {
    key: INSTALLATION_STAGE.PROGRESS,
    label: "En cours",
    description: "Livraison et installation",
    query: { status_group: "progress" },
  },
  {
    key: INSTALLATION_STAGE.DONE,
    label: "Terminées",
    description: "Installations clôturées",
    query: { status_group: "done" },
  },
]);

const PROGRESS_STATUSES = new Set([
  INSTALLATION_STATUS.READY_FOR_INSTALLATION,
  INSTALLATION_STATUS.SCHEDULED,
  INSTALLATION_STATUS.IN_PROGRESS,
]);

export function normalizeInstallationStatus(value) {
  if (value === "machine_created") return INSTALLATION_STATUS.INSTALLED;
  return value || INSTALLATION_STATUS.PENDING;
}

export function installationStage(status) {
  const normalized = normalizeInstallationStatus(status);
  if (normalized === INSTALLATION_STATUS.PENDING) return INSTALLATION_STAGE.PREPARE;
  if (normalized === INSTALLATION_STATUS.READY_FOR_DELIVERY) return INSTALLATION_STAGE.CONFIRMATION;
  if (PROGRESS_STATUSES.has(normalized)) return INSTALLATION_STAGE.PROGRESS;
  if (
    normalized === INSTALLATION_STATUS.INSTALLED
    || normalized === INSTALLATION_STATUS.ARCHIVED
  ) {
    return INSTALLATION_STAGE.DONE;
  }
  return null;
}

export function isInstallationInProgress(status) {
  return PROGRESS_STATUSES.has(normalizeInstallationStatus(status));
}
